export const moveToSolution = (toSolution, access, domain) => {
  if (toSolution === 'sales') {
    location.href = process.env.VUE_APP_SALES_PATH;
    return;
  }

  if (toSolution === 'sales_admin') {
    location.href = process.env.VUE_APP_SALES_ADMIN_PATH;
    return;
  }

  if (toSolution === 'hr') {
    if (access.hr) {
      location.href = process.env.VUE_APP_ERP_HR;
      return;
    }

    if (access.payroll) {
      location.href = `${process.env.VUE_APP_ERP_HR}/payroll-auth?callbackRoute=PayrollTab`;
      return;
    }

    if (access.contract) {
      location.href = `${process.env.VUE_APP_ERP_HR}/contracts/forms`;
      return;
    }

    if (access.office) {
      location.href = `${process.env.VUE_APP_OFFICE_HR_OLD_URL}/${domain}/insa/manage/insamanager`;
      return;
    }

    alert('사용 권한이 없습니다.\n인사근무 관리자에게 문의하세요.');
    return;
  }
  if (toSolution === 'bill') {
    if (access.bill) {
      location.href = `${process.env.VUE_APP_ERP_BILL}/${domain}/bill/manage/main`;
      return;
    }

    alert('사용 권한이 없습니다.\n경리회계 관리자에게 문의하세요.');
    return;
  }
  if (toSolution === 'accounting') {
    if (access.accounting) {
      location.href = process.env.VUE_APP_ERP_ACCOUNTING;
      return;
    }

    if (access.common) {
      location.href = process.env.VUE_APP_ERP_ACCOUNTING;
      return;
    }

    if (access.office) {
      location.href = `${process.env.VUE_APP_ERP_ACCOUNTING}/configuration/settings/manager`;
      return;
    }

    alert('사용 권한이 없습니다.\n경리회계 관리자에게 문의하세요.');
    return;
  }
  if (toSolution === 'asset') {
    if (access.asset) {
      location.href = `${process.env.VUE_APP_ASSET_URL}/properties-list`;
      return;
    }

    alert('사용 권한이 없습니다.\n자산관리자에게 문의하세요.');
  }
};
